import React from 'react';
import { Loader2 } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from 'shadcn/components/ui/Alert';
import { Badge } from 'shadcn/components/ui/Badge';
import { Button } from 'shadcn/components/ui/Button';

import { MispickUnpickedItemRow } from './MispickUnpickedItemRow';

/**
 * @param {Object} props
 * @param {Object} props.shipmentData
 * @param {Array} props.unpicked
 * @param {Record<string, 'picked'|'not_picked'>} props.decisions
 * @param {(sellableItemId: number, decision: 'picked'|'not_picked') => void} props.onDecisionChange
 * @param {() => void} props.onSubmit
 * @param {boolean} props.canSubmit
 * @param {boolean} props.isSubmitting
 */
function MispickUnpickedItems({
    canSubmit,
    decisions,
    isSubmitting,
    onDecisionChange,
    onSubmit,
    shipmentData,
    unpicked,
}) {
    return (
        <div className="space-y-4">
            <div className="flex flex-wrap items-center gap-2">
                <h2 className="text-lg font-medium">Order {shipmentData.orderNumber}</h2>
                <Badge variant="secondary">Pack line {shipmentData.packLineNumber}</Badge>
            </div>

            {unpicked.length === 0 ? (
                <Alert>
                    <AlertTitle>All set</AlertTitle>
                    <AlertDescription>No unpicked items remaining on this shipment.</AlertDescription>
                </Alert>
            ) : (
                <>
                    <ul className="space-y-3">
                        {unpicked.map((item) => (
                            <MispickUnpickedItemRow
                                key={item.sellableItemId}
                                item={item}
                                decision={decisions[item.sellableItemId]}
                                onDecisionChange={onDecisionChange}
                            />
                        ))}
                    </ul>

                    <Button disabled={!canSubmit || isSubmitting} onClick={onSubmit}>
                        {isSubmitting ? (
                            <>
                                <Loader2 className="animate-spin" aria-hidden />
                                Submitting…
                            </>
                        ) : (
                            'Submit Decisions'
                        )}
                    </Button>
                </>
            )}
        </div>
    );
}

export { MispickUnpickedItems };
